import { get_token, get_user_details } from "@/router";
import Swal from 'sweetalert2';
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue";
import MenuSideBar from '@/components/MenuSidebar/MenuSidebar.vue'

export default {
    components: {
      HomeNavBar,
      MenuSideBar
    },
    data: () => ({
        services: [],
        service_name: '',
        description: '',
        phone_number: '',
        isSubmitting: false,
        isLoading: false,
        selected_service: {} }),

      mounted() {
        this.fetch_services();
        this.token_exists = get_token();
        const userDetails = get_user_details();
        this.current_user_id = parseInt(userDetails.user_id, 10);
        this.current_role = userDetails.user_role;
      },
      methods: {
        edit_service(service) {
            this.selected_service = service;
            $('#editServiceModal').modal('show');
          },

        toggle_service_availability(service) {
            service.is_available = !service.is_available;
            const stored_services = JSON.parse(localStorage.getItem('services')) || {};
            stored_services[service.id] = service.is_available;
            localStorage.setItem('services', JSON.stringify(stored_services));
        },
        create_service() {
            this.isSubmitting = true;
            const formData = new FormData();
            formData.append('name', this.service_name);
            formData.append('description', this.description);
            formData.append('phone_number', this.phone_number);
        
            $.ajax({
                type: "POST",
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_service/`,
                headers: {
                    'Authorization': `Token ${this.getToken()}`
                },
                data: formData,
                processData: false,
                contentType: false,
                success: (response) => {
                    if (response.status === "success" && response.service_data) {
                        const new_service = {
                            ...response.service_data,
                            is_available: true
                        };
                        // Add it to the top of the list (no fetch, no reload)
                        this.services.unshift(new_service);
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: 'Service Created Successfully',
                            showConfirmButton: false,
                            timer: 2000,
                            position: 'bottom-end',
                            toast: true
                        });
                        // Hide modal and reset form
                        $('#create_service_modal').modal('hide');
                        this.service_name = '';
                        this.description = '';
                        this.phone_number = '';
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Service was created but not returned properly.',
                            position: 'bottom-end',
                            showConfirmButton: false,
                            timer: 3000,
                            toast: true
                        });
                    }
                },
                error: (response) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: response.responseJSON?.message || 'An error occurred while creating the service.',
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 3000,
                        toast: true
                    });
                },
                complete: () => {
                    this.isSubmitting = false;
                }
            });
        },

        getToken() {
            return get_token();
            },

        fetch_services() {
            this.isLoading = true;
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_services/`,
                method: 'GET',
                headers: {
                'Authorization': `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
                },
                success: (data) => {
                    const stored_services = JSON.parse(localStorage.getItem('services')) || {};
                    this.services = data.services.map(service => ({
                        ...service,
                        is_available: stored_services[service.id] !== undefined ? stored_services[service.id] : true,
                    }));                },
                complete: () => {
                this.isLoading = false;
                }
            });
            },

        update_service(service) {
            this.isSubmitting = true;
            $.ajax({
                type: "PUT",
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/edit_service/${service.id}/`,
                headers: {
                    'Authorization': `Token ${this.getToken()}`,
                },
                data: {
                    name: service.name,
                    description: service.description,
                    phone_number: service.phone_number,
                },
                success: (response) => {
                    const status = response.status;
                    if (status === "success") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: 'Service Updated Successfully',
                            showConfirmButton: false,
                            timer: 2000,
                            position: 'bottom-end',
                            toast: true
                        }).then(() => {
                            $('#editServiceModal').modal('hide');
                        });
                    }
                },
                    error: (response) => {
                        if (response.responseJSON && response.responseJSON.status === "error") {
                            // Handle error
                        } else {
                            console.error(response);
                        }
                    },
                    complete: () => {
                        this.isSubmitting = false;
                    }
                });
            },
      },


}